import { ROOM_SERVICE_LOCATION_TYPES } from '../../../../../services/exports/Constants';

export default {
  sections: {
    state: {
      title: 'Tila',
      fields: {
        room_service_visible: {
          label: 'Huone-/pöytäpalvelu näkyvissä',
        },
        has_room_service: {
          label: 'Huone-/pöytäpalvelu',
        },
      },
    },
    settings: {
      title: 'Asetukset',
      table_number: {
        label: 'Näytä pöytänumero',
      },
    },
    locations: {
      title: 'Sijainnit',
    },
  },
  form: {
    google_place: {
      label: 'Nimi',
      placeholder: 'Nimi Google Mapsissa',
    },
    type: {
      label: 'Tyyppi',
      options: {
        [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Huonepalvelu',
        [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Pöytäpalvelu',
      },
    },
    name: {
      label: 'Sijainnin nimi',
      placeholder: 'Kirjoita sijainnin nimi, joka on asiakkaalle selkeä',
    },
    street_name: {
      label: 'Katu',
      placeholder: 'Kadun nimi',
    },
    street_number: {
      label: 'Talon numero',
      placeholder: 'Talon numero',
    },
    city: {
      label: 'Kaupunki',
      placeholder: 'Kaupunki',
    },
    zip_code: {
      label: 'Postinumero',
      placeholder: 'Postinumero',
    },
  },
  fields: {
    id: 'tunnus',
    type: 'Tyyppi',
    name: 'Nimi',
    address: 'Osoite',
    is_active: 'Aktiivinen',
  },
  room_service_types: {
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Huonepalvelu',
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Pöytäpalvelu',
  },
  modals: {
    delete_location: {
      title: 'Oletko varma?',
      description: 'Tämä poistaa sijainnin "{{name}}"',
    },
  },
  buttons: {
    save: 'Tallenna',
    delete: 'Poista',
  },
  toasts: {
    failed_to_load_locations: 'Sijaintien lataaminen epäonnistui, lataa sivu uudelleen',
    failed_to_create_location: 'Sijainnin luominen epäonnistui',
    failed_to_toggle_location: 'Sijainnin saatavuuden muuttaminen epäonnistui',
    failed_to_delete_location: 'Sijainnin poistaminen epäonnistui',
    location_got_created: 'Sijainti luotu onnistuneesti',
    location_got_deleted: 'Sijainti poistettu',
    saving_success: 'Tallennettu onnistuneesti',
    saving_error: 'Tallennus epäonnistui',
  },
};
